export function fillArray(length: number, value?: any) {
  return Array.from({ length }, (_, i) => value ?? i + 1)
}

export const toArray = (obj: any) => (Array.isArray(obj) ? obj : [obj])

export const equalArray = <T,>(
  arr1: T[],
  arr2: T[],
  compareFn?: (val1: T, val2: T) => boolean,
  ignoreOrder?: boolean
) => {
  const _compare = (val1: T, val2: T) => (compareFn ? compareFn(val1, val2) : val1 === val2)
  if (ignoreOrder) {
    if (arr1.length !== arr2.length) return false
    const combineArr = [...arr1, ...arr2]
    for (const v of combineArr) {
      const arr1Count = arr1.filter((e) => _compare(e, v)).length
      const arr2Count = arr2.filter((e) => _compare(e, v)).length
      if (arr1Count !== arr2Count) return false
    }
    return true
  }
  return arr1.length === arr2.length && arr1.every((v, i) => _compare(v, arr2[i]))
}

export const isEmpty = (object: any) => JSON.stringify(object) === '{}'
